import { render } from "./ExternalLink.vue?vue&type=template&id=17f8ac3e&scoped=true"
import script from "./ExternalLink.vue?vue&type=script&lang=js"
export * from "./ExternalLink.vue?vue&type=script&lang=js"

import "./ExternalLink.vue?vue&type=style&index=0&id=17f8ac3e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f8ac3e"]])

export default __exports__